<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      园岭站<br>
站点介绍<br>
9号线园岭站位于红岭北路与笋岗路交界处。A出入口连接八卦一路美食街有着各式美食，B出入口有园岭新村，D出入口位于中民时代广场前。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:31	23:11	9号线	3分50秒	5分55秒<br>
文锦	06:16	23:57	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:31	23:11	9号线	4分25秒	5分55秒<br>
文锦	06:15	23:57	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:31	00:11	9号线	4分钟	5分55秒<br>
文锦	06:13	00:57	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
八卦一路、八卦岭邮政综合楼、旭飞花园、鹏盛年华、银泉大厦、装饰大厦<br><br>
B出入口:<br>
笋岗西路、红岭中路、园岭东路、深圳红岭中学、园岭实验小学、园岭新村、园岭一街小区<br><br>
C出入口:<br>
松园北街、深圳红岭小学、建设大厦、红岭公园、百汇大厦、长虹大厦、鸿翔花园、洪涛大厦、北京大厦<br><br>
D出入口:<br>
笋岗东路、深圳市人民检察院、深圳市残疾人联合会、物资控股大厦、万通大厦、中民时代广场<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 市检察院②<br>
23路、高峰专线29路、5路、222路、85路、M156路、M105<br><br>
A1出入口:<br>
公交站名： 市检察院①<br>
303路、322路、333路、385路、E25路、M152路、M463路<br><br>
C出入口:<br>
公交站名： 罗湖税务局②<br>
11路、13路、111路、M102路、M213路、M207路<br><br>
C出入口:<br>
公交站名： 园岭地铁站<br>
高峰专线33路、M156路、5路、107路、M329路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>